import { PUB_PDF_FONT_FAMILY, PUB_PDF_FONT_FILES } from "../const";

export const Styler = (props: { forAnonymous?: boolean }) => (
  <style>{`
    ${
      props.forAnonymous
        ? `
      @font-face {
        font-family: "Noto Sans JP";
        src: url("${PUB_PDF_FONT_FILES.regular}") format("woff2");
        font-weight: 400;
        font-style: normal;
        font-display: block;
      }
      @font-face {
        font-family: "Noto Sans JP";
        src: url("${PUB_PDF_FONT_FILES.bold}") format("woff2");
        font-weight: 700;
        font-style: normal;
        font-display: block;
      }

      .pubPdfRoot,
      .pubPdfRoot * {
        font-family: ${PUB_PDF_FONT_FAMILY} !important;
      }
    `
        : ""
    }

    @page {
      size: A4 landscape !important;
      margin: 0mm;
    }

    @media print {
      body {
        min-height: 1px;
      }
    }
  `}</style>
);
